export default __webpack_public_path__ + "static/media/mbwhite.dc90710a.png";